import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useErrorBoundary } from 'react-error-boundary';

import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

import { HeaderSecondary } from '../_shared';
import { BodyText, DisplayText, TitleText } from '../text';

const Container = styled.div(() => ({
  position: 'relative',
  top: '20rem',
  paddingTop: '10rem',
}));

const ContentWrapper = styled.div(({ theme }) => ({
  position: 'absolute',
  top: '20%',
  left: '50%',
  transform: 'translate(-50%)',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '4rem',

  width: '100rem',
  padding: '4rem',

  background: theme.color.base_white,
  borderRadius: '1rem',
  // boxShadow: theme.shadow.primary,
}));

const TextWrapper = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  gap: '1rem',
}));

const Button = styled.div(({ theme }) => ({
  padding: '1rem 2rem',
  background: theme.color.neutral400,
  borderRadius: '0.8rem',
  cursor: 'pointer',

  ':hover': {
    opacity: theme.hover.opacity,
  },
}));

const FallbackGlobal = () => {
  const theme = useTheme();

  const { pathname } = useLocation();

  const originalPathname = useRef(pathname);

  const { resetBoundary } = useErrorBoundary();

  useEffect(() => {
    if (pathname !== originalPathname.current) {
      resetBoundary();
    }
  }, [pathname, resetBoundary]);

  return (
    <>
      <HeaderSecondary />

      <Container>
        <ContentWrapper>
          <TextWrapper>
            <DisplayText size="sm">Something went wrong.</DisplayText>

            <TitleText size="lg">Please reload or check your connection</TitleText>
          </TextWrapper>

          <Button type="button" onClick={resetBoundary}>
            <BodyText color={theme.color.base_white}>RELOAD</BodyText>
          </Button>
        </ContentWrapper>
      </Container>
    </>
  );
};

export default FallbackGlobal;
